import React, { useEffect, useState, useContext, useRef } from "react";
import { Container, Form, Button } from "react-bootstrap";
import AuthContext from "../../context/AuthContext";
import { apiGet } from "../../utils/apiFetch";
import apiPath from "../../utils/apiPath";
import helpers from "../../utils/helpers";
import List from "./List";
import { isEmpty } from "lodash";

const Banking = () => {
  let { user, user_coins } = useContext(AuthContext);
  let user_by_created = user.id;
  const intervalRef = useRef(null);
  const [results, setResults] = useState([]);
  const [getLimit, setLimit] = useState({});
  const [search_params, setSearchParams] = useState({
    page: 1,
    limit: 5,
    keyword: "",
    status: "active",
    created_by: user_by_created,
  });

  const getLimitData = async () => {
    const { status, data: response_users } = await apiGet(apiPath.checkLimit);
    if (status === 200) {
      if (response_users.success) {
        setLimit(response_users.results);
      }
    }
  };

  const handlePageClick = (event) => {
    const params = { ...search_params, page: event.selected + 1 };
    setSearchParams(params);
    getUsers(params);
  };

  const [totalTable, setTotalTable] = useState({
    Balance: 0,
    Available: 0,
    Exposure: 0,
    Credit_Reference: 0,
    Reference: 0,
  });
  const getUsers = async (object) => {
    const { status, data: response_users } = await apiGet(
      apiPath.profileList,
      !isEmpty(object) ? object : search_params,
    );
    if (status === 200) {
      if (response_users.success) {
        setResults(response_users?.results || []);
        if (response_users?.results?.data?.length > 0) {
          let total = response_users?.results?.data?.reduce((res, acc) => {
            return (res += acc.totalCoins);
          }, 0);
          let Available = response_users?.results?.data?.reduce((res, acc) => {
            return (res += acc?.totalCoins1); //Math.abs(acc?.totalCoins - acc?.exposure
          }, 0);
          let Exposure = response_users?.results?.data?.reduce((res, acc) => {
            return (res += acc?.exposure);
          }, 0);
          let Reference = response_users?.results?.data?.reduce((res, acc) => {
            return (res += acc.totalCoins - acc.creditReference);
          }, 0);
          let creditReference = response_users?.results?.data?.reduce(
            (res, acc) => {
              return (res += acc.creditReference);
            },
            0,
          );
          setTotalTable({
            Balance: total,
            Available: Available,
            Exposure: Exposure,
            Credit_Reference: creditReference,
            Reference: Reference,
          });
        }
      }
    }
  };

  const refreshList = () => {
    getUsers();
  };

  useEffect(() => {
    getUsers();
    getLimitData();
  }, []);

// const latestParamsRef = useRef(search_params);

// useEffect(() => {
//   latestParamsRef.current = search_params;
// }, [search_params]);

// useEffect(() => {
//   const fetchUsers = () => {
//     getUsers(latestParamsRef.current);
//   };

//   fetchUsers();

//   intervalRef.current = setInterval(fetchUsers, 5000);

//   return () => clearInterval(intervalRef.current);
// }, []);
  return (
    <div>
      <div className="user_data_div">
        <section className="main-inner-outer py-0">
          <Container fluid className="px-0">
            <div className="find-member-sec search_banking_detail">
              <Form id={"searchForm"} style={{ position: `relative` }}>
                <Form.Group className="position-relative">
                  <Form.Control
                    type="text"
                    placeholder="Find member..."
                    value={search_params?.keyword}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\s+$/, "");
                      setSearchParams((prevState) => {
                        return {
                          ...prevState,
                          keyword: value,
                          page: 1,
                        };
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group className="d-flex align-items-center ps-3 mb-3 mb-sm-0">
                  <Form.Label className="pe-3 mb-0">Status</Form.Label>
                  <Form.Select
                    aria-label="Default select example"
                    value={search_params?.status}
                    onChange={(e) => {
                      const params = {
                        ...search_params,
                        status: e.target.value,
                      };
                      setSearchParams(params);
                      getUsers(params);
                    }}
                  >
                    <option value="active">Active</option>
                    <option value="suspend">Suspend</option>
                    <option value="locked">Locked</option>
                    <option value="">All</option>
                  </Form.Select>
                </Form.Group>
                <Button className="search-btn" onClick={() => getUsers()}>
                  Search
                </Button>
                <button
                  className="btn"
                  type="button"
                  onClick={() => {
                    const params = {
                      page: 1,
                      limit: 5,
                      keyword: "",
                      status: "active",
                      created_by: user_by_created,
                    };
                    setSearchParams(params);
                    getUsers(params);
                  }}
                >
                  {" "}
                  <i className="fas fa-redo-alt"></i>
                </button>
              </Form>

              <div className="inner-wrapper">
                <div className="common-container">
                  <div className="bet_status bank_balance_detail d-sm-flex align-items-center my-1 my-sm-3">
                    <h6 className="mb-0">Your Balance </h6>
                    <strong>
                      <small>PBU</small>
                      {helpers.currencyFormat(user_coins)}
                    </strong>
                  </div>

                  <List
                    results={results}
                    handlePageClick={handlePageClick}
                    refreshList={refreshList}
                    totalTable={totalTable}
                    getLimit={getLimit}
                  />
                </div>
              </div>
            </div>
          </Container>
        </section>
      </div>
    </div>
  );
};

export default Banking;
